import {
  FETCH_ORGANISATIONS_REQUEST,
  FETCH_ORGANISATIONS_SUCCESS,
  FETCH_ORGANISATIONS_FAILURE,
  ADD_ORGANIZATION_REQUEST,
  ADD_ORGANIZATION_SUCCESS,
  ADD_ORGANIZATION_FAILURE,
  UPDATE_ORGANIZATION_REQUEST,
  UPDATE_ORGANIZATION_SUCCESS,
  UPDATE_ORGANIZATION_FAILURE,
  RESET_ADD_ORGANIZATION_STATUS,
  FETCH_ORGANIZATION_DETAILS_REQUEST,
  FETCH_ORGANIZATION_DETAILS_SUCCESS,
  FETCH_ORGANIZATION_DETAILS_FAILURE,
  RESET_UPDATE_ORGANIZATION_STATUS, 
  SAVE_OPENAI_KEY_REQUEST,  // ✅ Add this
  SAVE_OPENAI_KEY_SUCCESS,  // ✅ Add this
  SAVE_OPENAI_KEY_FAILURE, 
  GET_OPENAI_KEY_REQUEST,
  GET_OPENAI_KEY_SUCCESS,
  GET_OPENAI_KEY_FAILURE,
  DELETE_OPENAI_KEY_REQUEST,
  DELETE_OPENAI_KEY_SUCCESS,
  DELETE_OPENAI_KEY_FAILURE, // ✅ Add this
// new
} from '../actions/adminConsoleAction';

const initialState = {
  organisations: [],
  loading: false,
  error: null,
  addOrganizationStatus: null,
  details: null,
  updateOrganizationStatus: null,
  saveOpenAIKeyStatus: null,
  openAIKey: null,
};



const organisationReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ORGANISATIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_ORGANISATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        organisations: action.payload,
      };
    case FETCH_ORGANISATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ADD_ORGANIZATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ADD_ORGANIZATION_SUCCESS:
      return {
        ...state,
        loading: false,
        organisations: [...state.organisations, action.payload.organization],
        addOrganizationStatus: action.payload.status,
      };
    case ADD_ORGANIZATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case RESET_ADD_ORGANIZATION_STATUS:
      return {
        ...state,
        addOrganizationStatus: null,
      };
    case FETCH_ORGANIZATION_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_ORGANIZATION_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        details: action.payload,
      };
    case FETCH_ORGANIZATION_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
      
      case UPDATE_ORGANIZATION_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case UPDATE_ORGANIZATION_SUCCESS:
        return {
          ...state,
          loading: false,
          organisations: [...state.organisations, action.payload.organization],
          updateOrganizationStatus: action.payload.status,
        };
      case UPDATE_ORGANIZATION_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      case RESET_UPDATE_ORGANIZATION_STATUS:
        return {
          ...state,
          updateOrganizationStatus: null,
      };
      case SAVE_OPENAI_KEY_REQUEST:
  return {
    ...state,
    loading: true,
    error: null,
  };

case SAVE_OPENAI_KEY_SUCCESS:
  return {
    ...state,
    loading: false,
    saveOpenAIKeyStatus: action.payload, // Store the response status
  };

case SAVE_OPENAI_KEY_FAILURE:
  return {
    ...state,
    loading: false,
    error: action.payload,
  };

  case GET_OPENAI_KEY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_OPENAI_KEY_SUCCESS:
      return {
        ...state,
        loading: false,
        openAIKey: action.payload["openai-key"] ?? "", 
      };
    case GET_OPENAI_KEY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Handle Delete OpenAI Key
    case DELETE_OPENAI_KEY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_OPENAI_KEY_SUCCESS:
      return {
        ...state,
        loading: false,
        openAIKey: null, // Remove OpenAI Key from state
      };
    case DELETE_OPENAI_KEY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default organisationReducer;
